import React from "react"

export default function FabricOptions({ item }) {
  if (item.org)
    return (
      <div className="d-flex justify-content-between">
        <div>{item.org.number}</div>
        <div>
          {item.org.brand}, {item.org.bunch}
        </div>
      </div>
    )
  return <span>{item.label}</span>
}
